module.exports = __webpack_public_path__ + "img/img-1.d16d98c7.webp";